import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OAuthStorage } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs';
import { ShipmentApiUrlService } from '../services/shipment-api-url.service';
import { environment } from 'src/environments/environment';

const waybillsBearerToken = "e959fda0-6f75-3007-b436-3f8728eb76b8";

@Injectable({
  providedIn: 'root'
})
export class OAuthInterceptor implements HttpInterceptor {

  constructor(private authStorage: OAuthStorage,
    private shipmentApiUrlService: ShipmentApiUrlService
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let url = req.url.toLowerCase();
    if (!this.requiresAccessToken(url)) return next.handle(req);

    let authorizationHeader = this.getAuthorizationHeader(url);
    let headers = req.headers.set('Authorization', authorizationHeader);
    req = req.clone({ headers });
    return next.handle(req);
  }

  requiresAccessToken(url: string): boolean {
    let found = this.getProtectedUrls().find(u => url.startsWith(u));
    return !!found;
  }

  getAuthorizationHeader(url: string) {
    const allowdUrls = [this.shipmentApiUrlService.getCurrentUrl(), environment.agenciesApiUrl, environment.settlementsApiUrl, environment.logisticsDocumentsApiUrl, environment.gatewayUrl, environment.helpApiUrl];
    const matchedUrl = allowdUrls.find(allowedUrl => url.startsWith(allowedUrl));
    let authorizationHeader: string = '';
    if (matchedUrl === undefined) {
      return authorizationHeader;
    }
    if (matchedUrl === environment.waybillsApiUrl) {
      
      authorizationHeader = 'Bearer ' + waybillsBearerToken;
      return authorizationHeader;
    }
    return authorizationHeader = 'Bearer ' + this.authStorage.getItem('access_token');
  }

  private getProtectedUrls(): string[] {
    return [
      this.shipmentApiUrlService.getCurrentUrl(),
      environment.waybillsApiUrl,
      environment.agenciesApiUrl,
      environment.settlementsApiUrl,
      environment.logisticsDocumentsApiUrl,
      environment.gatewayUrl,
      environment.helpApiUrl
    ];
  }
}
